import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  Signal,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { toSignal } from "@angular/core/rxjs-interop";
import { Observable } from "rxjs";

import { Category } from "src/app/routes/catalog/models/category.model";
import { Product } from "src/app/routes/catalog/models/product.model";
import { Page } from "../../models/page.model";
import { Seo } from "../../services/seo.service";
import { CoreSelectors } from "../../store/selectors";
import {
  BreadcrumbItem,
  BreadcrumbService,
} from "../../services/breadcrumb.service";
import { RouterLink } from "@angular/router";
import { UrlPipe } from "../../pipes/url.pipe";

@Component({
  selector: "audio-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.sass"],
  imports: [RouterLink, UrlPipe],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  private store = inject<Store>(Store);
  private seo = inject(Seo);
  private breadcrumbService = inject(BreadcrumbService);

  breadcrumb$: Observable<Category | Product | Page | null | undefined> = this.store.pipe(
    select(CoreSelectors.getBreadcrumb),
  );
  $position: Signal<Category | Product | Page | null | undefined> = toSignal(
    this.breadcrumb$,
  );
  $items: Signal<BreadcrumbItem[]> = computed(() =>
    this.breadcrumbService.getItems(this.$position()),
  );

  constructor() {
    effect(() => {
      this.seo.setCanonicalURL(
        this.$items()?.[this.$items()?.length - 1]?.url ?? "",
      );
    });
  }
}
